export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Upload: { input: any; output: any; }
};

export type AdminUpdateEntryBlockInput = {
  block: Scalars['Boolean']['input'];
  id: Scalars['Int']['input'];
};

export type AppChecksType = {
  __typename?: 'AppChecksType';
  /** Returns the number of QR codes a user has (does not include shared ones) */
  countUserQrs: Scalars['Int']['output'];
  /** Returns the number of QR codes scheduled for deletion by user */
  countUserQrsForDeletion: Scalars['Int']['output'];
  /** Checks if the user exists in the database. Does not throw an exception */
  emailExists: Scalars['Boolean']['output'];
};


export type AppChecksTypeEmailExistsArgs = {
  email: Scalars['String']['input'];
};

export type AppConstraintKeyType = {
  __typename?: 'AppConstraintKeyType';
  exampleMessage: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type AppErrorKeyType = {
  __typename?: 'AppErrorKeyType';
  exampleMessage: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type AppType = {
  __typename?: 'AppType';
  /** Getting all registered validation error keys in an application. */
  constraintKeys: Array<AppConstraintKeyType>;
  /** Getting all registered error keys in an application. */
  errorKeys: Array<AppErrorKeyType>;
  isSwitchedUser: Scalars['Boolean']['output'];
};

export type ArtQrDescriptionType = {
  __typename?: 'ArtQrDescriptionType';
  qrSettings: ArtQrSettingsType;
};

export type ArtQrSettingsType = {
  __typename?: 'ArtQrSettingsType';
  backgroundImage?: Maybe<Scalars['String']['output']>;
  backgroundImageSize?: Maybe<Scalars['Float']['output']>;
  dotColor: Scalars['String']['output'];
  dotGradient: GradientOptionsType;
  dotType: Scalars['String']['output'];
  innerEyeColor: Scalars['String']['output'];
  innerEyeGradient: GradientOptionsType;
  innerEyeType?: Maybe<Scalars['String']['output']>;
  isSingleDotColor: Scalars['Boolean']['output'];
  isSingleInnerEyeColor: Scalars['Boolean']['output'];
  isSingleOuterEyeColor: Scalars['Boolean']['output'];
  outerEyeColor: Scalars['String']['output'];
  outerEyeGradient: GradientOptionsType;
  outerEyeType?: Maybe<Scalars['String']['output']>;
};

export type BaseQrDescriptionType = {
  __typename?: 'BaseQrDescriptionType';
  qrFrame?: Maybe<BaseQrFrameType>;
  qrSettings: BaseQrSettingsType;
};

export type BaseQrFrameType = {
  __typename?: 'BaseQrFrameType';
  backgroundColor: Scalars['String']['output'];
  color: Scalars['String']['output'];
  isTextToggle: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  text: Scalars['String']['output'];
  textColor: Scalars['String']['output'];
  textFont: Scalars['String']['output'];
  textSize?: Maybe<Scalars['Int']['output']>;
};

export type BaseQrSettingsType = {
  __typename?: 'BaseQrSettingsType';
  dotBackgroundColor: Scalars['String']['output'];
  dotBackgroundGradient: GradientOptionsType;
  dotColor: Scalars['String']['output'];
  dotGradient: GradientOptionsType;
  dotType: Scalars['String']['output'];
  errorCorrectionLevel: Scalars['String']['output'];
  innerEyeColor: Scalars['String']['output'];
  innerEyeGradient: GradientOptionsType;
  innerEyeType?: Maybe<Scalars['String']['output']>;
  isLogotypeBackground: Scalars['Boolean']['output'];
  isSingleDotBackgroundColor: Scalars['Boolean']['output'];
  isSingleDotColor: Scalars['Boolean']['output'];
  isSingleInnerEyeColor: Scalars['Boolean']['output'];
  isSingleOuterEyeColor: Scalars['Boolean']['output'];
  logotype?: Maybe<Scalars['String']['output']>;
  logotypeMargin: Scalars['Float']['output'];
  logotypeSize: Scalars['Float']['output'];
  outerEyeColor: Scalars['String']['output'];
  outerEyeGradient: GradientOptionsType;
  outerEyeType?: Maybe<Scalars['String']['output']>;
};

export type BulkMoveToFolderInput = {
  entries: Array<Scalars['Int']['input']>;
  folderId: Scalars['Int']['input'];
};

export type ChangeOwnerRequestInput = {
  email: Scalars['String']['input'];
  entryIds: Array<Scalars['Int']['input']>;
};

export type CityPaginatedType = {
  __typename?: 'CityPaginatedType';
  count: Scalars['Int']['output'];
  items: Array<CityType>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type CityType = {
  __typename?: 'CityType';
  geonameId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  region?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CompanyParentCategory = {
  __typename?: 'CompanyParentCategory';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  uniqueId: Scalars['String']['output'];
};

export type CountryPaginatedType = {
  __typename?: 'CountryPaginatedType';
  count: Scalars['Int']['output'];
  items: Array<CountryType>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type CountryPricesType = {
  __typename?: 'CountryPricesType';
  countryCode: Scalars['String']['output'];
  plansPrices: Array<PlanPricesType>;
};

export type CountryType = {
  __typename?: 'CountryType';
  code: Scalars['String']['output'];
  conversionRate: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type CreateReferrerWithdrawalInput = {
  amount: Scalars['Float']['input'];
  bankAddress?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  cityId?: InputMaybe<Scalars['Int']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  payoneerAccount?: InputMaybe<Scalars['String']['input']>;
  recipientAddress?: InputMaybe<Scalars['String']['input']>;
  recipientAddressIndex?: InputMaybe<Scalars['String']['input']>;
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  recipientName?: InputMaybe<Scalars['String']['input']>;
  recipientPhone?: InputMaybe<Scalars['String']['input']>;
  recipientType?: InputMaybe<Scalars['Int']['input']>;
  saved?: Scalars['Boolean']['input'];
  swiftBic?: InputMaybe<Scalars['String']['input']>;
  type: GqlReferrerWithdrawalType;
};

export type CreateSubfolderInput = {
  name: Scalars['String']['input'];
  parentId: Scalars['Int']['input'];
};

export type CurrencyPricesType = {
  __typename?: 'CurrencyPricesType';
  currencyCode: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  priceForPeriods?: Maybe<Scalars['Float']['output']>;
  pricePerUnit?: Maybe<Scalars['Float']['output']>;
  promocodeDiscount?: Maybe<Scalars['Float']['output']>;
};

export type DomainType = {
  __typename?: 'DomainType';
  faviconName?: Maybe<Scalars['String']['output']>;
  faviconUrl?: Maybe<Scalars['String']['output']>;
  isSsl: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sslEndDate: Scalars['String']['output'];
  sslStartDate: Scalars['String']['output'];
};


export type DomainTypeSslEndDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type DomainTypeSslStartDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type EditEntryDomainInput = {
  domainName: Scalars['String']['input'];
  entryId: Scalars['Int']['input'];
  favicon?: InputMaybe<Scalars['Upload']['input']>;
  removeFavicon?: Scalars['Boolean']['input'];
};

export type EditEntryTitleInput = {
  id: Scalars['Int']['input'];
  title: Scalars['String']['input'];
};

export type EditEntryTypeInput = {
  entryId: Scalars['Int']['input'];
  newType: GqlQrType;
};

export type EditEntryUniqueKeyInput = {
  id: Scalars['Int']['input'];
  uniqueKey: Scalars['String']['input'];
};

export type EditEntryUrlInput = {
  id: Scalars['Int']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};

export type EditFolderDomainInput = {
  domainName: Scalars['String']['input'];
  favicon?: InputMaybe<Scalars['Upload']['input']>;
  folderId: Scalars['Int']['input'];
  removeFavicon?: Scalars['Boolean']['input'];
};

export type EditUserDomainInput = {
  domainName: Scalars['String']['input'];
  favicon?: InputMaybe<Scalars['Upload']['input']>;
  removeFavicon?: Scalars['Boolean']['input'];
};

export type EntityType = {
  __typename?: 'EntityType';
  /** Getting full entry data for specified id (only for owner of specified id) */
  entry?: Maybe<EntryType>;
  /** Getting full folder data for specified id (only for owner of specified id) */
  folder?: Maybe<FolderType>;
};


export type EntityTypeEntryArgs = {
  id: Scalars['Int']['input'];
};


export type EntityTypeFolderArgs = {
  id: Scalars['Int']['input'];
};

export type EntriesChangeOwnerNotificationType = {
  __typename?: 'EntriesChangeOwnerNotificationType';
  entryCount: Scalars['Int']['output'];
  ownerUsername: Scalars['String']['output'];
};

export type EntryAbTestInput = {
  alternativeUrl?: InputMaybe<Scalars['String']['input']>;
  chance?: InputMaybe<Scalars['Int']['input']>;
  items?: InputMaybe<Array<EntryAbTestItemInput>>;
};

export type EntryAbTestItemInput = {
  alternativeUrl: Scalars['String']['input'];
  chance: Scalars['Int']['input'];
  countryId: Scalars['Int']['input'];
};

export type EntryAbTestItemType = {
  __typename?: 'EntryAbTestItemType';
  alternativeUrl: Scalars['String']['output'];
  chance: Scalars['Int']['output'];
  countryId: Scalars['Int']['output'];
};

export type EntryAbTestType = {
  __typename?: 'EntryAbTestType';
  alternativeUrl?: Maybe<Scalars['String']['output']>;
  chance?: Maybe<Scalars['Int']['output']>;
  items: Array<EntryAbTestItemType>;
};

export type EntryCouponSummaryType = {
  __typename?: 'EntryCouponSummaryType';
  redemptionEnabled: Scalars['Boolean']['output'];
  redemptionLimit?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  successfulRedemptionsCount: Scalars['Int']['output'];
};

export type EntryDataType = {
  __typename?: 'EntryDataType';
  userEntries: EntryPaginatedType;
};


export type EntryDataTypeUserEntriesArgs = {
  paginationArgs: EntryPaginationArgs;
};

export type EntryExpirationDateInput = {
  expiredDate?: InputMaybe<Scalars['String']['input']>;
  isActive?: Scalars['Boolean']['input'];
};

export type EntryExpirationDateType = {
  __typename?: 'EntryExpirationDateType';
  expiredDate?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
};


export type EntryExpirationDateTypeExpiredDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type EntryGeoTargetingInput = {
  items?: Array<EntryGeoTargetingItemInput>;
};

export type EntryGeoTargetingItemInput = {
  countryId: Scalars['Int']['input'];
  url: Scalars['String']['input'];
};

export type EntryGeoTargetingItemType = {
  __typename?: 'EntryGeoTargetingItemType';
  countryId: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type EntryGeoTargetingType = {
  __typename?: 'EntryGeoTargetingType';
  items: Array<EntryGeoTargetingItemType>;
};

export type EntryLanguageInput = {
  /** Entry ids */
  ids: Array<Scalars['Int']['input']>;
  languageId?: InputMaybe<Scalars['Int']['input']>;
};

export type EntryLinkType = {
  __typename?: 'EntryLinkType';
  id?: Maybe<Scalars['Int']['output']>;
  link?: Maybe<Scalars['String']['output']>;
};

export type EntryLocationInput = {
  hint?: InputMaybe<Scalars['String']['input']>;
  isActive?: Scalars['Boolean']['input'];
  isExactRequired?: Scalars['Boolean']['input'];
  locations?: Array<EntryLocationItemInput>;
};

export type EntryLocationItemInput = {
  cityId?: InputMaybe<Scalars['Int']['input']>;
  countryId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  radius?: Scalars['Float']['input'];
  rule: GqlLocationRestrictionRule;
};

export type EntryLocationItemType = {
  __typename?: 'EntryLocationItemType';
  city?: Maybe<CityType>;
  country?: Maybe<CountryType>;
  id: Scalars['Int']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
  rule: GqlLocationRestrictionRule;
};

export type EntryLocationType = {
  __typename?: 'EntryLocationType';
  hint?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isExactRequired: Scalars['Boolean']['output'];
  locations: Array<EntryLocationItemType>;
};

export type EntryMarketingInput = {
  abTest?: InputMaybe<EntryAbTestInput>;
  activeType: Scalars['String']['input'];
  geoTargeting?: InputMaybe<EntryGeoTargetingInput>;
  /** Entry ids */
  ids: Array<Scalars['Int']['input']>;
  mobileTargeting?: InputMaybe<EntryMobileTargetingInput>;
  openGraph?: InputMaybe<EntryOpenGraphInput>;
  savedLinkUtmOverride?: InputMaybe<EntryShortLinkUtmOverrideInput>;
  savedShortLinkUtmOverride?: InputMaybe<EntryShortLinkUtmOverrideInput>;
  utmConfig?: InputMaybe<EntryUtmConfigInput>;
};

export type EntryMarketingType = {
  __typename?: 'EntryMarketingType';
  abTest: EntryAbTestType;
  activeRedirectType?: Maybe<Scalars['String']['output']>;
  geoTargeting: EntryGeoTargetingType;
  mobileTargeting?: Maybe<EntryMobileTargetingType>;
  openGraph?: Maybe<EntryOpenGraphType>;
  savedLinkUtmOverride?: Maybe<EntryShortLinkUtmOverrideType>;
  savedShortLinkUtmOverride?: Maybe<EntryShortLinkUtmOverrideType>;
  utmConfig?: Maybe<EntryUtmConfigType>;
};

export type EntryMobileTargetingInput = {
  androidUrl?: InputMaybe<Scalars['String']['input']>;
  iosUrl?: InputMaybe<Scalars['String']['input']>;
};

export type EntryMobileTargetingType = {
  __typename?: 'EntryMobileTargetingType';
  androidUrl?: Maybe<Scalars['String']['output']>;
  iosUrl?: Maybe<Scalars['String']['output']>;
};

export type EntryOpenGraphInput = {
  canonicalUrl?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageDescription?: InputMaybe<Scalars['String']['input']>;
  imageHeight?: InputMaybe<Scalars['Int']['input']>;
  imageMimeType?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  imageWidth?: InputMaybe<Scalars['Int']['input']>;
  isEnabled?: Scalars['Boolean']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type EntryOpenGraphType = {
  __typename?: 'EntryOpenGraphType';
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  imageDescription?: Maybe<Scalars['String']['output']>;
  imageHeight?: Maybe<Scalars['Int']['output']>;
  imageMimeType?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  imageWidth?: Maybe<Scalars['Int']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type EntryPaginatedType = {
  __typename?: 'EntryPaginatedType';
  count: Scalars['Int']['output'];
  items: Array<EntryType>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
  userEntryTypes: Array<GqlQrType>;
};

export type EntryPaginationArgs = {
  /** The categories of entry types returned. Summarized with the `types` argument. */
  categoriesTypes?: InputMaybe<Array<GqlQrCategoryTypes>>;
  /** Filter QR codes by their location in the directory. Does not take precedence over the `folderId` argument. */
  folderFilter?: InputMaybe<GqlEntryFolderFilter>;
  /** Getting entries for a specified folder id. Takes precedence over the `folderFilter` argument. */
  folderId?: InputMaybe<Scalars['Int']['input']>;
  /** Getting entries for a specified ids. */
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** If true, the selection will return only deleted entries. Default is false. */
  isOnlyDeleted?: Scalars['Boolean']['input'];
  /** If true, returns shared QR codes from other users. Default is true. */
  isReturnShared?: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: Scalars['Int']['input'];
  /** Search by id, title, uniqueKey, url. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Sorting returned entries by specific filters. */
  sort?: InputMaybe<GqlEntrySort>;
  /** List of returned entry types. Summarized with the `categoryTypes` argument. */
  types?: InputMaybe<Array<GqlQrType>>;
};

export type EntryPasswordInput = {
  hint?: InputMaybe<Scalars['String']['input']>;
  isActive?: Scalars['Boolean']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

export type EntryPasswordType = {
  __typename?: 'EntryPasswordType';
  hint?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  password?: Maybe<Scalars['String']['output']>;
};

export type EntryPropertiesType = {
  __typename?: 'EntryPropertiesType';
  hasVisualization: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  qrDescription: QrDescriptionUnion;
};

export type EntryRedirectType = {
  __typename?: 'EntryRedirectType';
  entry: EntryType;
  redirectUrl: Scalars['String']['output'];
};

export type EntryRestrictionsInput = {
  expirationDate?: InputMaybe<EntryExpirationDateInput>;
  /** Entry ids */
  ids: Array<Scalars['Int']['input']>;
  locationAccess?: InputMaybe<EntryLocationInput>;
  password?: InputMaybe<EntryPasswordInput>;
  scanLimit?: InputMaybe<EntryScanLimitInput>;
  scheduleAccess?: InputMaybe<EntryScheduleInput>;
};

export type EntryRestrictionsType = {
  __typename?: 'EntryRestrictionsType';
  expirationDate: EntryExpirationDateType;
  locationAccess: EntryLocationType;
  password: EntryPasswordType;
  scanLimit: EntryScanLimitType;
  scheduleAccess: EntryScheduleType;
};

export type EntryScanLimitInput = {
  hint?: InputMaybe<Scalars['String']['input']>;
  isActive?: Scalars['Boolean']['input'];
  scanLimitType?: InputMaybe<GqlScanLimitType>;
  scanValue?: InputMaybe<Scalars['Int']['input']>;
};

export type EntryScanLimitType = {
  __typename?: 'EntryScanLimitType';
  hint?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  scanLimitType: GqlScanLimitType;
  scanValue?: Maybe<Scalars['Int']['output']>;
};

export type EntryScheduleInput = {
  additionalLink?: InputMaybe<Scalars['String']['input']>;
  dateEnd?: InputMaybe<Scalars['String']['input']>;
  dateStart?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  isActive?: Scalars['Boolean']['input'];
  isShouldDeleteFile?: Scalars['Boolean']['input'];
  schedules?: Array<EntryScheduleItemInput>;
  showNothing?: Scalars['Boolean']['input'];
  timezoneId?: InputMaybe<Scalars['Int']['input']>;
};

export type EntryScheduleItemInput = {
  additionalLink?: InputMaybe<Scalars['String']['input']>;
  dateEnd?: InputMaybe<Scalars['String']['input']>;
  dateStart?: InputMaybe<Scalars['String']['input']>;
  day: GqlRestrictionDay;
  file?: InputMaybe<Scalars['Upload']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive?: Scalars['Boolean']['input'];
  isShouldDeleteFile?: Scalars['Boolean']['input'];
};

export type EntryScheduleItemType = {
  __typename?: 'EntryScheduleItemType';
  additionalLink?: Maybe<Scalars['String']['output']>;
  dateEnd?: Maybe<Scalars['String']['output']>;
  dateStart?: Maybe<Scalars['String']['output']>;
  day?: Maybe<GqlRestrictionDay>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
};


export type EntryScheduleItemTypeDateEndArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type EntryScheduleItemTypeDateStartArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type EntryScheduleType = {
  __typename?: 'EntryScheduleType';
  additionalLink?: Maybe<Scalars['String']['output']>;
  dateEnd?: Maybe<Scalars['String']['output']>;
  dateStart?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  schedules: Array<EntryScheduleItemType>;
  showNothing: Scalars['Boolean']['output'];
  timezone?: Maybe<TimezoneType>;
};


export type EntryScheduleTypeDateEndArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type EntryScheduleTypeDateStartArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type EntryScriptInput = {
  /** Entry ids */
  ids: Array<Scalars['Int']['input']>;
  script?: InputMaybe<Scalars['String']['input']>;
};

export type EntryShortLinkUtmOverrideInput = {
  campaign?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type EntryShortLinkUtmOverrideType = {
  __typename?: 'EntryShortLinkUtmOverrideType';
  campaign?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Scalars['String']['output']>;
};

export type EntryTemplateType = {
  __typename?: 'EntryTemplateType';
  id: Scalars['Int']['output'];
  qrDescription: QrDescriptionUnion;
};

export type EntryType = {
  __typename?: 'EntryType';
  block: Scalars['Boolean']['output'];
  constructorPreviewUrl?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<EntryCouponSummaryType>;
  createdAt: Scalars['String']['output'];
  daysUntilDeletion?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<DomainType>;
  entryLink?: Maybe<EntryLinkType>;
  /** Returns the total size of files in bytes by QR code, if it is of file type, otherwise null. */
  filesSize?: Maybe<Scalars['Int']['output']>;
  folderId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isFileType: Scalars['Boolean']['output'];
  isLinkType: Scalars['Boolean']['output'];
  isLiteStatus: Scalars['Boolean']['output'];
  isStatic: Scalars['Boolean']['output'];
  language?: Maybe<LanguageType>;
  lastScanDate?: Maybe<Scalars['String']['output']>;
  link: Scalars['String']['output'];
  marketing: EntryMarketingType;
  previewUrl?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<EntryPropertiesType>;
  qrDomain?: Maybe<Scalars['String']['output']>;
  qrDownload?: Maybe<QrDownloadType>;
  restrictions: EntryRestrictionsType;
  scans?: Maybe<Scalars['Int']['output']>;
  script?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: GqlQrType;
  uniqueKey?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};


export type EntryTypeCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type EntryTypeDeletedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type EntryTypeLastScanDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type EntryTypeQrDownloadArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
};


export type EntryTypeUpdatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type EntryUtmConfigInput = {
  allowUtmOverrides?: InputMaybe<Scalars['Boolean']['input']>;
  campaign?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: Scalars['Boolean']['input'];
  medium?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type EntryUtmConfigType = {
  __typename?: 'EntryUtmConfigType';
  allowUtmOverrides: Scalars['Boolean']['output'];
  campaign: Scalars['String']['output'];
  content?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  medium: Scalars['String']['output'];
  source: Scalars['String']['output'];
  term?: Maybe<Scalars['String']['output']>;
};

export type FolderAbTestItemType = {
  __typename?: 'FolderAbTestItemType';
  alternativeUrl: Scalars['String']['output'];
  chance: Scalars['Int']['output'];
  countryId: Scalars['Int']['output'];
};

export type FolderAbTestType = {
  __typename?: 'FolderAbTestType';
  alternativeUrl?: Maybe<Scalars['String']['output']>;
  chance?: Maybe<Scalars['Int']['output']>;
  items: Array<FolderAbTestItemType>;
};

export type FolderChangeOwnerNotificationType = {
  __typename?: 'FolderChangeOwnerNotificationType';
  folderId: Scalars['Int']['output'];
  folderName: Scalars['String']['output'];
  folderOwnerId: Scalars['Int']['output'];
  folderOwnerUsername: Scalars['String']['output'];
  requestId: Scalars['Int']['output'];
};

export type FolderCreateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FolderExpirationDateInput = {
  expiredDate?: InputMaybe<Scalars['String']['input']>;
  isActive?: Scalars['Boolean']['input'];
};

export type FolderExpirationDateType = {
  __typename?: 'FolderExpirationDateType';
  expiredDate?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
};


export type FolderExpirationDateTypeExpiredDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type FolderGeoTargetingItemType = {
  __typename?: 'FolderGeoTargetingItemType';
  countryId: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type FolderGeoTargetingType = {
  __typename?: 'FolderGeoTargetingType';
  items: Array<FolderGeoTargetingItemType>;
};

export type FolderLanguageInput = {
  /** Folder id */
  id: Scalars['Int']['input'];
  languageId?: InputMaybe<Scalars['Int']['input']>;
};

export type FolderLocationInput = {
  hint?: InputMaybe<Scalars['String']['input']>;
  isActive?: Scalars['Boolean']['input'];
  isExactRequired?: Scalars['Boolean']['input'];
  locations?: Array<FolderLocationItemInput>;
};

export type FolderLocationItemInput = {
  cityId?: InputMaybe<Scalars['Int']['input']>;
  countryId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  radius?: Scalars['Float']['input'];
  rule: GqlLocationRestrictionRule;
};

export type FolderLocationItemType = {
  __typename?: 'FolderLocationItemType';
  city?: Maybe<CityType>;
  country?: Maybe<CountryType>;
  id: Scalars['Int']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
  rule: GqlLocationRestrictionRule;
};

export type FolderLocationType = {
  __typename?: 'FolderLocationType';
  hint?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  isExactRequired: Scalars['Boolean']['output'];
  locations: Array<FolderLocationItemType>;
};

export type FolderMarketingInput = {
  abTest?: InputMaybe<EntryAbTestInput>;
  activeType: Scalars['String']['input'];
  geoTargeting?: InputMaybe<EntryGeoTargetingInput>;
  id: Scalars['Int']['input'];
  mobileTargeting?: InputMaybe<EntryMobileTargetingInput>;
  openGraph?: InputMaybe<EntryOpenGraphInput>;
  utmConfig?: InputMaybe<EntryUtmConfigInput>;
};

export type FolderMarketingType = {
  __typename?: 'FolderMarketingType';
  abTest: FolderAbTestType;
  activeRedirectType?: Maybe<Scalars['String']['output']>;
  geoTargeting: FolderGeoTargetingType;
  mobileTargeting?: Maybe<FolderMobileTargetingType>;
  openGraph?: Maybe<FolderOpenGraphType>;
  utmConfig?: Maybe<FolderUtmConfigType>;
};

export type FolderMobileTargetingType = {
  __typename?: 'FolderMobileTargetingType';
  androidUrl?: Maybe<Scalars['String']['output']>;
  iosUrl?: Maybe<Scalars['String']['output']>;
};

export type FolderOpenGraphType = {
  __typename?: 'FolderOpenGraphType';
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  imageDescription?: Maybe<Scalars['String']['output']>;
  imageHeight?: Maybe<Scalars['Int']['output']>;
  imageMimeType?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  imageWidth?: Maybe<Scalars['Int']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type FolderPasswordInput = {
  hint?: InputMaybe<Scalars['String']['input']>;
  isActive?: Scalars['Boolean']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

export type FolderPasswordType = {
  __typename?: 'FolderPasswordType';
  hint?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  password?: Maybe<Scalars['String']['output']>;
};

export type FolderReportOutput = {
  __typename?: 'FolderReportOutput';
  downloadUrl?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  reportKey: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type FolderRestrictionsInput = {
  expirationDate?: InputMaybe<FolderExpirationDateInput>;
  /** Folder id */
  id: Scalars['Int']['input'];
  locationAccess?: InputMaybe<FolderLocationInput>;
  password?: InputMaybe<FolderPasswordInput>;
  scanLimit?: InputMaybe<FolderScanLimitInput>;
  scheduleAccess?: InputMaybe<FolderScheduleInput>;
};

export type FolderRestrictionsType = {
  __typename?: 'FolderRestrictionsType';
  expirationDate: FolderExpirationDateType;
  locationAccess: FolderLocationType;
  password: FolderPasswordType;
  scanLimit: FolderScanLimitType;
  scheduleAccess: FolderScheduleType;
};

export type FolderScanLimitInput = {
  hint?: InputMaybe<Scalars['String']['input']>;
  isActive?: Scalars['Boolean']['input'];
  scanLimitType?: InputMaybe<GqlScanLimitType>;
  scanValue?: InputMaybe<Scalars['Int']['input']>;
};

export type FolderScanLimitType = {
  __typename?: 'FolderScanLimitType';
  hint?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  scanLimitType: GqlScanLimitType;
  scanValue?: Maybe<Scalars['Int']['output']>;
};

export type FolderScheduleInput = {
  additionalLink?: InputMaybe<Scalars['String']['input']>;
  dateEnd?: InputMaybe<Scalars['String']['input']>;
  dateStart?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  isActive?: Scalars['Boolean']['input'];
  isShouldDeleteFile?: Scalars['Boolean']['input'];
  schedules?: Array<FolderScheduleItemInput>;
  showNothing?: Scalars['Boolean']['input'];
  timezoneId?: InputMaybe<Scalars['Int']['input']>;
};

export type FolderScheduleItemInput = {
  additionalLink?: InputMaybe<Scalars['String']['input']>;
  dateEnd?: InputMaybe<Scalars['String']['input']>;
  dateStart?: InputMaybe<Scalars['String']['input']>;
  day: GqlRestrictionDay;
  file?: InputMaybe<Scalars['Upload']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive?: Scalars['Boolean']['input'];
  isShouldDeleteFile?: Scalars['Boolean']['input'];
};

export type FolderScheduleItemType = {
  __typename?: 'FolderScheduleItemType';
  additionalLink?: Maybe<Scalars['String']['output']>;
  dateEnd?: Maybe<Scalars['String']['output']>;
  dateStart?: Maybe<Scalars['String']['output']>;
  day?: Maybe<GqlRestrictionDay>;
  fileName?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
};


export type FolderScheduleItemTypeDateEndArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type FolderScheduleItemTypeDateStartArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type FolderScheduleType = {
  __typename?: 'FolderScheduleType';
  additionalLink?: Maybe<Scalars['String']['output']>;
  dateEnd?: Maybe<Scalars['String']['output']>;
  dateStart?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  schedules: Array<FolderScheduleItemType>;
  showNothing: Scalars['Boolean']['output'];
  timezone?: Maybe<TimezoneType>;
};


export type FolderScheduleTypeDateEndArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type FolderScheduleTypeDateStartArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type FolderScriptInput = {
  /** Folder id */
  id: Scalars['Int']['input'];
  script?: InputMaybe<Scalars['String']['input']>;
};

export type FolderShareNotificationType = {
  __typename?: 'FolderShareNotificationType';
  folderId: Scalars['Int']['output'];
  folderName: Scalars['String']['output'];
  folderOwnerId: Scalars['Int']['output'];
  folderOwnerUsername: Scalars['String']['output'];
  requestId: Scalars['Int']['output'];
  role: GqlSharedUserRole;
};

export type FolderSharedUserType = {
  __typename?: 'FolderSharedUserType';
  id: Scalars['Int']['output'];
  role: GqlSharedUserRole;
  status: GqlShareFolderStatus;
  userId: Scalars['Int']['output'];
  username: Scalars['String']['output'];
};

export type FolderType = {
  __typename?: 'FolderType';
  createdAt: Scalars['String']['output'];
  domain?: Maybe<DomainType>;
  id: Scalars['Int']['output'];
  isBlocked: Scalars['Boolean']['output'];
  isOwnerPremium: Scalars['Boolean']['output'];
  isShared: Scalars['Boolean']['output'];
  language?: Maybe<LanguageType>;
  marketing: FolderMarketingType;
  name: Scalars['String']['output'];
  parentFolderId?: Maybe<Scalars['Int']['output']>;
  qrCount: Scalars['Int']['output'];
  restrictions: FolderRestrictionsType;
  script?: Maybe<Scalars['String']['output']>;
  sharedUsers: Array<FolderSharedUserType>;
  subfolders: Array<FolderType>;
  userOwnerEmail: Scalars['String']['output'];
  userOwnerId: Scalars['Int']['output'];
};


export type FolderTypeCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type FolderUndownloadedReportOutput = {
  __typename?: 'FolderUndownloadedReportOutput';
  createdAt?: Maybe<Scalars['String']['output']>;
  downloadUrl: Scalars['String']['output'];
  extension?: Maybe<Scalars['String']['output']>;
  folderId: Scalars['Int']['output'];
  folderName: Scalars['String']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<GqlFolderReportStatus>;
};


export type FolderUndownloadedReportOutputCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type FolderUpdateInput = {
  accessEmail?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  submitEmail?: Scalars['Boolean']['input'];
};

export type FolderUtmConfigType = {
  __typename?: 'FolderUtmConfigType';
  campaign: Scalars['String']['output'];
  content?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  medium: Scalars['String']['output'];
  source: Scalars['String']['output'];
  term?: Maybe<Scalars['String']['output']>;
};

export type FolderZipOutput = {
  __typename?: 'FolderZipOutput';
  extension?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<GqlFolderReportStatus>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GeoDataType = {
  __typename?: 'GeoDataType';
  cities: CityPaginatedType;
  countries: CountryPaginatedType;
  languages: LanguagePaginatedType;
  timezones: TimezonePaginatedType;
};


export type GeoDataTypeCitiesArgs = {
  countryIdFilter?: InputMaybe<Scalars['Int']['input']>;
  paginationArgs: GqlPaginationArgs;
};


export type GeoDataTypeCountriesArgs = {
  paginationArgs: GqlPaginationArgs;
};


export type GeoDataTypeLanguagesArgs = {
  paginationArgs: GqlPaginationArgs;
};


export type GeoDataTypeTimezonesArgs = {
  paginationArgs: GqlPaginationArgs;
};

export const GqlEntryFolderFilter = {
  /** Returns only QR codes that are located in the directory. */
  InFonder: 'IN_FONDER',
  /** Returns only QR codes that are not located in a directory. */
  NotInFolder: 'NOT_IN_FOLDER'
} as const;

export type GqlEntryFolderFilter = typeof GqlEntryFolderFilter[keyof typeof GqlEntryFolderFilter];
export const GqlEntrySort = {
  ByPopularity: 'BY_POPULARITY',
  FromAToZ: 'FROM_A_TO_Z',
  FromZToA: 'FROM_Z_TO_A',
  LastEdit: 'LAST_EDIT',
  LastScanned: 'LAST_SCANNED',
  NewFirst: 'NEW_FIRST',
  OldFirst: 'OLD_FIRST'
} as const;

export type GqlEntrySort = typeof GqlEntrySort[keyof typeof GqlEntrySort];
export const GqlFolderReportStatus = {
  Completed: 'COMPLETED',
  Failed: 'FAILED',
  Pending: 'PENDING'
} as const;

export type GqlFolderReportStatus = typeof GqlFolderReportStatus[keyof typeof GqlFolderReportStatus];
export const GqlFrontCurrencyPage = {
  HomePage: 'HOME_PAGE',
  ProductPage: 'PRODUCT_PAGE',
  SubscriptionPage: 'SUBSCRIPTION_PAGE'
} as const;

export type GqlFrontCurrencyPage = typeof GqlFrontCurrencyPage[keyof typeof GqlFrontCurrencyPage];
export const GqlInvoiceStatus = {
  Fail: 'FAIL',
  Refund: 'REFUND',
  Success: 'SUCCESS'
} as const;

export type GqlInvoiceStatus = typeof GqlInvoiceStatus[keyof typeof GqlInvoiceStatus];
export const GqlLocationRestrictionRule = {
  QrRuleAvailable: 'QR_RULE_AVAILABLE',
  QrRuleNotAvailable: 'QR_RULE_NOT_AVAILABLE'
} as const;

export type GqlLocationRestrictionRule = typeof GqlLocationRestrictionRule[keyof typeof GqlLocationRestrictionRule];
export const GqlOrderKey = {
  Lite: 'LITE',
  Premium: 'PREMIUM',
  Single: 'SINGLE',
  Storage: 'STORAGE'
} as const;

export type GqlOrderKey = typeof GqlOrderKey[keyof typeof GqlOrderKey];
export type GqlPaginationArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<GqlSortOrder>;
};

export const GqlPaymentServiceName = {
  MeQr: 'ME_QR',
  MeQrV2: 'ME_QR_V2'
} as const;

export type GqlPaymentServiceName = typeof GqlPaymentServiceName[keyof typeof GqlPaymentServiceName];
export const GqlQrCategoryTypes = {
  AllFiles: 'ALL_FILES',
  File: 'FILE',
  Link: 'LINK',
  MultiFiles: 'MULTI_FILES',
  Phone: 'PHONE'
} as const;

export type GqlQrCategoryTypes = typeof GqlQrCategoryTypes[keyof typeof GqlQrCategoryTypes];
export const GqlQrCodesSelection = {
  AllQrCodes: 'ALL_QR_CODES',
  SelectedQrCodes: 'SELECTED_QR_CODES'
} as const;

export type GqlQrCodesSelection = typeof GqlQrCodesSelection[keyof typeof GqlQrCodesSelection];
export const GqlQrType = {
  Amazon: 'AMAZON',
  Attendance: 'ATTENDANCE',
  Audio: 'AUDIO',
  Barcode: 'BARCODE',
  Booking: 'BOOKING',
  Calendar: 'CALENDAR',
  Constructor: 'CONSTRUCTOR',
  Coupon: 'COUPON',
  Discord: 'DISCORD',
  Email: 'EMAIL',
  Etsy: 'ETSY',
  Excel: 'EXCEL',
  Facebook: 'FACEBOOK',
  File: 'FILE',
  Gallery: 'GALLERY',
  GoogleDoc: 'GOOGLE_DOC',
  GoogleForm: 'GOOGLE_FORM',
  GoogleReview: 'GOOGLE_REVIEW',
  GoogleSheet: 'GOOGLE_SHEET',
  Image: 'IMAGE',
  Instagram: 'INSTAGRAM',
  Jpg: 'JPG',
  Kakaotalk: 'KAKAOTALK',
  Line: 'LINE',
  Link: 'LINK',
  Linkedin: 'LINKEDIN',
  ListOfLinks: 'LIST_OF_LINKS',
  Logo: 'LOGO',
  Map: 'MAP',
  MultiPayment: 'MULTI_PAYMENT',
  MultiUrl: 'MULTI_URL',
  NewConstructor: 'NEW_CONSTRUCTOR',
  Office_365: 'OFFICE_365',
  Payment: 'PAYMENT',
  Paypal: 'PAYPAL',
  Pcr: 'PCR',
  Pdf: 'PDF',
  Phone: 'PHONE',
  Png: 'PNG',
  PowerPoint: 'POWER_POINT',
  Reddit: 'REDDIT',
  Revolut: 'REVOLUT',
  Shaped: 'SHAPED',
  ShortLink: 'SHORT_LINK',
  Sms: 'SMS',
  Snapchat: 'SNAPCHAT',
  SocialMedia: 'SOCIAL_MEDIA',
  SocialMediaV2: 'SOCIAL_MEDIA_V2',
  Soundcloud: 'SOUNDCLOUD',
  Spotify: 'SPOTIFY',
  StaticEmailType: 'STATIC_EMAIL_TYPE',
  StaticLinkType: 'STATIC_LINK_TYPE',
  StaticMapType: 'STATIC_MAP_TYPE',
  StaticPaymentType: 'STATIC_PAYMENT_TYPE',
  StaticPhoneType: 'STATIC_PHONE_TYPE',
  StaticPixType: 'STATIC_PIX_TYPE',
  StaticSmsType: 'STATIC_SMS_TYPE',
  StaticTextType: 'STATIC_TEXT_TYPE',
  StaticVcardType: 'STATIC_VCARD_TYPE',
  StaticWhatsappType: 'STATIC_WHATSAPP_TYPE',
  StaticWifiType: 'STATIC_WIFI_TYPE',
  StoreLink: 'STORE_LINK',
  Telegram: 'TELEGRAM',
  Text: 'TEXT',
  Tiktok: 'TIKTOK',
  Twitter: 'TWITTER',
  Upi: 'UPI',
  Vcard: 'VCARD',
  Venmo: 'VENMO',
  Video: 'VIDEO',
  Wechat: 'WECHAT',
  WhatsApp: 'WHATS_APP',
  Wifi: 'WIFI',
  Youtube: 'YOUTUBE'
} as const;

export type GqlQrType = typeof GqlQrType[keyof typeof GqlQrType];
export const GqlRecipientType = {
  Business: 'BUSINESS',
  Private: 'PRIVATE'
} as const;

export type GqlRecipientType = typeof GqlRecipientType[keyof typeof GqlRecipientType];
export const GqlReferrerWithdrawalStatus = {
  Completed: 'COMPLETED',
  Pending: 'PENDING'
} as const;

export type GqlReferrerWithdrawalStatus = typeof GqlReferrerWithdrawalStatus[keyof typeof GqlReferrerWithdrawalStatus];
export const GqlReferrerWithdrawalType = {
  Payoneer: 'PAYONEER',
  Swift: 'SWIFT'
} as const;

export type GqlReferrerWithdrawalType = typeof GqlReferrerWithdrawalType[keyof typeof GqlReferrerWithdrawalType];
export const GqlRestrictionDay = {
  Friday: 'FRIDAY',
  Monday: 'MONDAY',
  Saturday: 'SATURDAY',
  Sunday: 'SUNDAY',
  Thursday: 'THURSDAY',
  Tuesday: 'TUESDAY',
  Wednesday: 'WEDNESDAY'
} as const;

export type GqlRestrictionDay = typeof GqlRestrictionDay[keyof typeof GqlRestrictionDay];
export const GqlScanLimitType = {
  Total: 'TOTAL',
  Unique: 'UNIQUE'
} as const;

export type GqlScanLimitType = typeof GqlScanLimitType[keyof typeof GqlScanLimitType];
export const GqlShareFolderStatus = {
  Shared: 'SHARED',
  Waiting: 'WAITING'
} as const;

export type GqlShareFolderStatus = typeof GqlShareFolderStatus[keyof typeof GqlShareFolderStatus];
export const GqlSharedUserRole = {
  RoleEdit: 'ROLE_EDIT',
  RoleView: 'ROLE_VIEW'
} as const;

export type GqlSharedUserRole = typeof GqlSharedUserRole[keyof typeof GqlSharedUserRole];
export const GqlSortOrder = {
  Asc: 'ASC',
  Desc: 'DESC'
} as const;

export type GqlSortOrder = typeof GqlSortOrder[keyof typeof GqlSortOrder];
export const GqlSubscriptionFirstStatus = {
  Fail: 'FAIL',
  Success: 'SUCCESS'
} as const;

export type GqlSubscriptionFirstStatus = typeof GqlSubscriptionFirstStatus[keyof typeof GqlSubscriptionFirstStatus];
export const GqlSubscriptionPlan = {
  LiteMonthly: 'LITE_MONTHLY',
  LiteYearly: 'LITE_YEARLY',
  OldPremiumMonthly: 'OLD_PREMIUM_MONTHLY',
  OldPremiumYearly: 'OLD_PREMIUM_YEARLY',
  OldStorage_1GbMonthly: 'OLD_STORAGE_1_GB_MONTHLY',
  OldStorage_1GbYearly: 'OLD_STORAGE_1_GB_YEARLY',
  OldStorage_1TbMonthly: 'OLD_STORAGE_1_TB_MONTHLY',
  OldStorage_1TbYearly: 'OLD_STORAGE_1_TB_YEARLY',
  OldStorage_10GbMonthly: 'OLD_STORAGE_10_GB_MONTHLY',
  OldStorage_10GbYearly: 'OLD_STORAGE_10_GB_YEARLY',
  OldStorage_10TbMonthly: 'OLD_STORAGE_10_TB_MONTHLY',
  OldStorage_10TbYearly: 'OLD_STORAGE_10_TB_YEARLY',
  OldStorage_100GbMonthly: 'OLD_STORAGE_100_GB_MONTHLY',
  OldStorage_100GbYearly: 'OLD_STORAGE_100_GB_YEARLY',
  OldStorage_100MbMonthly: 'OLD_STORAGE_100_MB_MONTHLY',
  OldStorage_100MbYearly: 'OLD_STORAGE_100_MB_YEARLY',
  OldStorage_300MbMonthly: 'OLD_STORAGE_300_MB_MONTHLY',
  OldStorage_300MbYearly: 'OLD_STORAGE_300_MB_YEARLY',
  OldStorage_500MbMonthly: 'OLD_STORAGE_500_MB_MONTHLY',
  OldStorage_500MbYearly: 'OLD_STORAGE_500_MB_YEARLY',
  PremiumMonthly: 'PREMIUM_MONTHLY',
  PremiumYearly: 'PREMIUM_YEARLY',
  StorageMonthly: 'STORAGE_MONTHLY',
  StorageYearly: 'STORAGE_YEARLY'
} as const;

export type GqlSubscriptionPlan = typeof GqlSubscriptionPlan[keyof typeof GqlSubscriptionPlan];
export const GqlSubscriptionProvider = {
  Apple: 'APPLE',
  Google: 'GOOGLE',
  Stripe: 'STRIPE'
} as const;

export type GqlSubscriptionProvider = typeof GqlSubscriptionProvider[keyof typeof GqlSubscriptionProvider];
export const GqlSubscriptionStatus = {
  Cancel: 'CANCEL',
  Fail: 'FAIL',
  New: 'NEW',
  Refund: 'REFUND',
  Success: 'SUCCESS'
} as const;

export type GqlSubscriptionStatus = typeof GqlSubscriptionStatus[keyof typeof GqlSubscriptionStatus];
export const GqlUserEmailNotification = {
  Daily: 'DAILY',
  EachScan: 'EACH_SCAN',
  Monthly: 'MONTHLY',
  Weekly: 'WEEKLY'
} as const;

export type GqlUserEmailNotification = typeof GqlUserEmailNotification[keyof typeof GqlUserEmailNotification];
export const GqlUserRole = {
  RoleAdmin: 'ROLE_ADMIN',
  RolePdfUser: 'ROLE_PDF_USER',
  RoleSuperAdmin: 'ROLE_SUPER_ADMIN',
  RoleUser: 'ROLE_USER'
} as const;

export type GqlUserRole = typeof GqlUserRole[keyof typeof GqlUserRole];
export const GqlUserSegment = {
  BigBusiness: 'BIG_BUSINESS',
  DontKnow: 'DONT_KNOW',
  Information: 'INFORMATION',
  NonProfitOrganizations: 'NON_PROFIT_ORGANIZATIONS',
  Personal: 'PERSONAL'
} as const;

export type GqlUserSegment = typeof GqlUserSegment[keyof typeof GqlUserSegment];
export type GradientColorType = {
  __typename?: 'GradientColorType';
  color: Scalars['String']['output'];
  offset: Scalars['Float']['output'];
};

export type GradientOptionsType = {
  __typename?: 'GradientOptionsType';
  colors: Array<GradientColorType>;
  rotation: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type IntegrationInfoType = {
  __typename?: 'IntegrationInfoType';
  qrCreationLimit: Scalars['Int']['output'];
  tokens: Array<IntegrationTokenType>;
  totalCreatedQrCount: Scalars['Int']['output'];
};

export type IntegrationTokenType = {
  __typename?: 'IntegrationTokenType';
  expire?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
};


export type IntegrationTokenTypeExpireArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type LanguagePaginatedType = {
  __typename?: 'LanguagePaginatedType';
  count: Scalars['Int']['output'];
  items: Array<LanguageType>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type LanguageType = {
  __typename?: 'LanguageType';
  id: Scalars['Int']['output'];
  locale: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type LiteChangeResultOutput = {
  __typename?: 'LiteChangeResultOutput';
  disabledEntryId?: Maybe<Scalars['Int']['output']>;
  enableEntryId?: Maybe<Scalars['Int']['output']>;
  enableLiteId: Scalars['Int']['output'];
};

export type LiteMiddlewareInput = {
  coupon?: InputMaybe<Scalars['String']['input']>;
  currencyCode?: Scalars['String']['input'];
  entryId?: InputMaybe<Scalars['Int']['input']>;
  planId: Scalars['Int']['input'];
  quantityOrder?: InputMaybe<Scalars['Int']['input']>;
  serviceName: GqlPaymentServiceName;
  targetCancelLink?: InputMaybe<Scalars['String']['input']>;
  targetSuccessLink?: InputMaybe<Scalars['String']['input']>;
};

export type LiteSubscriptionType = {
  __typename?: 'LiteSubscriptionType';
  activeOrder?: Maybe<PaymentOrderType>;
  customerPortalUrl?: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['String']['output'];
  entryId?: Maybe<Scalars['Int']['output']>;
  entryTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isCancellationPeriod: Scalars['Boolean']['output'];
  isExistSubscription: Scalars['Boolean']['output'];
  isMultipleOrder: Scalars['Boolean']['output'];
  subscriptionDueDate?: Maybe<Scalars['String']['output']>;
};


export type LiteSubscriptionTypeCustomerPortalUrlArgs = {
  backUrl?: InputMaybe<Scalars['String']['input']>;
};


export type LiteSubscriptionTypeDueDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type LiteSubscriptionTypeSubscriptionDueDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type LiteToggleResultOutput = {
  __typename?: 'LiteToggleResultOutput';
  disableEntry?: Maybe<Scalars['Int']['output']>;
  enableEntry?: Maybe<Scalars['Int']['output']>;
};

export type MarketingType = {
  __typename?: 'MarketingType';
  userCompanyParentCategories: Array<CompanyParentCategory>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addAlternativeEmail: UserType;
  adminEditEntryUniqueKey: EntryType;
  adminSetEntryQrDomain: EntryType;
  adminUpdateEntryBlock: EntryType;
  bulkCopyEntry: Scalars['Boolean']['output'];
  cancelChangeOwnerRequest: Scalars['Boolean']['output'];
  /** Cancels the qr code removal deletion schedule */
  cancelQrDeletion: EntryType;
  cancelSubscription: Scalars['Boolean']['output'];
  changeEntriesOwner: Scalars['Boolean']['output'];
  changeFolderOwner: Scalars['Boolean']['output'];
  changeQrForLite: LiteChangeResultOutput;
  clearEntryCache: Scalars['Boolean']['output'];
  confirmTwoFactor: Scalars['Boolean']['output'];
  createFolder: FolderType;
  createReferrerWithdrawal: Scalars['Boolean']['output'];
  createSubfolder: Scalars['Boolean']['output'];
  creteNewApiKey: IntegrationTokenType;
  deleteAccount: Scalars['Boolean']['output'];
  deleteAlternativeEmail: UserType;
  deleteApiKey: Scalars['Boolean']['output'];
  deleteEntries: Scalars['Boolean']['output'];
  deleteEntryDomain: Scalars['Boolean']['output'];
  deleteFolder: Scalars['Boolean']['output'];
  deleteFolderDomain: Scalars['Boolean']['output'];
  deleteFolderReport: Scalars['Boolean']['output'];
  deleteUserDomain: Scalars['Boolean']['output'];
  disableTwoFactor: Scalars['Boolean']['output'];
  downloadFolderQrZip: FolderZipOutput;
  editEntryDomain: Scalars['Boolean']['output'];
  editEntryTitle: Scalars['Boolean']['output'];
  editEntryType: EntryRedirectType;
  editEntryUrl: EntryType;
  editFolder: Scalars['Boolean']['output'];
  editFolderDomain: Scalars['Boolean']['output'];
  editUserDomain: Scalars['Boolean']['output'];
  generateOrGetFolderReport: FolderReportOutput;
  importCsv?: Maybe<Scalars['String']['output']>;
  importShortLinkCsv: ShortLinkCsvImportResultOutput;
  liteMiddleware: Scalars['String']['output'];
  logUserTabAccess: Scalars['Boolean']['output'];
  markFolderReportDownloaded: Scalars['Boolean']['output'];
  moveFolder: Scalars['Boolean']['output'];
  premiumMiddleware: Scalars['String']['output'];
  recoveryEntry: EntryRedirectType;
  recoveryShortLinkEntry: Scalars['Boolean']['output'];
  requestPasswordResetEmail: Scalars['Boolean']['output'];
  resendAlternativeEmail: UserType;
  respondToChangeEntriesOwner: Scalars['Boolean']['output'];
  respondToChangeFolderOwner: Scalars['Boolean']['output'];
  respondToFolderShare: Scalars['Boolean']['output'];
  revokePermission: Scalars['Boolean']['output'];
  saveQrPreviewImage: Scalars['String']['output'];
  saveUserSegment: UserType;
  sendSupportMessage: Scalars['Boolean']['output'];
  sendVerifyEmail: Scalars['Boolean']['output'];
  setBulkToFolder: Scalars['Boolean']['output'];
  setNoFolder: Scalars['Boolean']['output'];
  shareFolder: Scalars['Boolean']['output'];
  storageMiddleware: Scalars['String']['output'];
  toggleLiteForQr: LiteToggleResultOutput;
  updateAdditionalInvoiceEmail: UserType;
  updateEntryLanguage: EntryType;
  updateEntryMarketing?: Maybe<EntryType>;
  updateEntryRestrictions: EntryType;
  updateEntryScript: EntryType;
  updateFolderLanguage: FolderType;
  updateFolderMarketing: FolderType;
  updateFolderRestrictions: FolderType;
  updateFolderScript: FolderType;
  updateProfileGeneral: UserType;
  updateProfileNotifications: UserType;
  updateProfilePassword: UserType;
  verifyDomain: Scalars['Boolean']['output'];
};


export type MutationAddAlternativeEmailArgs = {
  input: ProfileAlternativeEmailInput;
};


export type MutationAdminEditEntryUniqueKeyArgs = {
  input: EditEntryUniqueKeyInput;
};


export type MutationAdminSetEntryQrDomainArgs = {
  domain: Scalars['String']['input'];
  id: Scalars['Int']['input'];
};


export type MutationAdminUpdateEntryBlockArgs = {
  input: AdminUpdateEntryBlockInput;
};


export type MutationBulkCopyEntryArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationCancelQrDeletionArgs = {
  id: Scalars['Int']['input'];
};


export type MutationCancelSubscriptionArgs = {
  orderId: Scalars['Int']['input'];
  planId: GqlSubscriptionPlan;
};


export type MutationChangeEntriesOwnerArgs = {
  input: ChangeOwnerRequestInput;
};


export type MutationChangeFolderOwnerArgs = {
  email: Scalars['String']['input'];
  folderId: Scalars['Int']['input'];
};


export type MutationChangeQrForLiteArgs = {
  entryId: Scalars['Int']['input'];
  liteId: Scalars['Int']['input'];
};


export type MutationClearEntryCacheArgs = {
  id: Scalars['Int']['input'];
};


export type MutationConfirmTwoFactorArgs = {
  code: Scalars['String']['input'];
};


export type MutationCreateFolderArgs = {
  input: FolderCreateInput;
};


export type MutationCreateReferrerWithdrawalArgs = {
  input: CreateReferrerWithdrawalInput;
};


export type MutationCreateSubfolderArgs = {
  input: CreateSubfolderInput;
};


export type MutationDeleteAlternativeEmailArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteApiKeyArgs = {
  tokenId: Scalars['Int']['input'];
};


export type MutationDeleteEntriesArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationDeleteEntryDomainArgs = {
  entryId: Scalars['Int']['input'];
};


export type MutationDeleteFolderArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteFolderDomainArgs = {
  folderId: Scalars['Int']['input'];
};


export type MutationDeleteFolderReportArgs = {
  reportKey: Scalars['String']['input'];
};


export type MutationDisableTwoFactorArgs = {
  code: Scalars['String']['input'];
};


export type MutationDownloadFolderQrZipArgs = {
  extension?: InputMaybe<Scalars['String']['input']>;
  folderId: Scalars['Int']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationEditEntryDomainArgs = {
  input: EditEntryDomainInput;
};


export type MutationEditEntryTitleArgs = {
  input: EditEntryTitleInput;
};


export type MutationEditEntryTypeArgs = {
  input: EditEntryTypeInput;
};


export type MutationEditEntryUrlArgs = {
  input: EditEntryUrlInput;
};


export type MutationEditFolderArgs = {
  input: FolderUpdateInput;
};


export type MutationEditFolderDomainArgs = {
  input: EditFolderDomainInput;
};


export type MutationEditUserDomainArgs = {
  input: EditUserDomainInput;
};


export type MutationGenerateOrGetFolderReportArgs = {
  folderId: Scalars['Int']['input'];
};


export type MutationImportCsvArgs = {
  csv: Scalars['Upload']['input'];
  template?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationImportShortLinkCsvArgs = {
  csv: Scalars['Upload']['input'];
};


export type MutationLiteMiddlewareArgs = {
  input: LiteMiddlewareInput;
};


export type MutationLogUserTabAccessArgs = {
  input: UserTabLogInput;
};


export type MutationMarkFolderReportDownloadedArgs = {
  folderId: Scalars['Int']['input'];
};


export type MutationMoveFolderArgs = {
  childrenId: Scalars['Int']['input'];
  parentId: Scalars['Int']['input'];
};


export type MutationPremiumMiddlewareArgs = {
  input: PremiumMiddlewareInput;
};


export type MutationRecoveryEntryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRecoveryShortLinkEntryArgs = {
  id: Scalars['Int']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestPasswordResetEmailArgs = {
  username: Scalars['String']['input'];
};


export type MutationResendAlternativeEmailArgs = {
  id: Scalars['Int']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRespondToChangeEntriesOwnerArgs = {
  isAccept: Scalars['Boolean']['input'];
  ownerUsername: Scalars['String']['input'];
};


export type MutationRespondToChangeFolderOwnerArgs = {
  isAccept: Scalars['Boolean']['input'];
  requestId: Scalars['Int']['input'];
};


export type MutationRespondToFolderShareArgs = {
  isAccept: Scalars['Boolean']['input'];
  requestId: Scalars['Int']['input'];
};


export type MutationRevokePermissionArgs = {
  id: Scalars['Int']['input'];
  status: GqlShareFolderStatus;
};


export type MutationSaveQrPreviewImageArgs = {
  id: Scalars['Int']['input'];
  image: Scalars['String']['input'];
};


export type MutationSaveUserSegmentArgs = {
  segment: GqlUserSegment;
};


export type MutationSendSupportMessageArgs = {
  input: SupportMessageInput;
};


export type MutationSetBulkToFolderArgs = {
  input: BulkMoveToFolderInput;
};


export type MutationSetNoFolderArgs = {
  input: SetNoFolderInput;
};


export type MutationShareFolderArgs = {
  input: ShareFolderInput;
};


export type MutationStorageMiddlewareArgs = {
  input: StorageMiddlewareInput;
};


export type MutationToggleLiteForQrArgs = {
  entryId: Scalars['Int']['input'];
  isEnable: Scalars['Boolean']['input'];
};


export type MutationUpdateAdditionalInvoiceEmailArgs = {
  input: ProfileAdditionalInvoiceEmailInput;
};


export type MutationUpdateEntryLanguageArgs = {
  input: EntryLanguageInput;
};


export type MutationUpdateEntryMarketingArgs = {
  input: EntryMarketingInput;
};


export type MutationUpdateEntryRestrictionsArgs = {
  input: EntryRestrictionsInput;
};


export type MutationUpdateEntryScriptArgs = {
  input: EntryScriptInput;
};


export type MutationUpdateFolderLanguageArgs = {
  input: FolderLanguageInput;
};


export type MutationUpdateFolderMarketingArgs = {
  input: FolderMarketingInput;
};


export type MutationUpdateFolderRestrictionsArgs = {
  input: FolderRestrictionsInput;
};


export type MutationUpdateFolderScriptArgs = {
  input: FolderScriptInput;
};


export type MutationUpdateProfileGeneralArgs = {
  input: ProfileGeneralInput;
};


export type MutationUpdateProfileNotificationsArgs = {
  input: ProfileNotificationsInput;
};


export type MutationUpdateProfilePasswordArgs = {
  input: ProfilePasswordInput;
};


export type MutationVerifyDomainArgs = {
  input: VerifyDomainInput;
};

export type NotificationsType = {
  __typename?: 'NotificationsType';
  requestsToChangeEntriesOwner: Array<EntriesChangeOwnerNotificationType>;
  requestsToChangeFolderOwner: Array<FolderChangeOwnerNotificationType>;
  requestsToFolderShare: Array<FolderShareNotificationType>;
};

export type PaymentCurrencyType = {
  __typename?: 'PaymentCurrencyType';
  decimalSeparator: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isAllowedForPayPal: Scalars['Boolean']['output'];
  isAllowedForUpi: Scalars['Boolean']['output'];
  isIntegerCurrency: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  sign: Scalars['String']['output'];
};

export type PaymentOrderType = {
  __typename?: 'PaymentOrderType';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['String']['output'];
  currency: PaymentCurrencyType;
  currencyAmount?: Maybe<Scalars['Float']['output']>;
  customerEmail?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  discountInCent?: Maybe<Scalars['Int']['output']>;
  finalAmount: Scalars['Float']['output'];
  finalAmountInCent: Scalars['Float']['output'];
  firstStatus?: Maybe<GqlSubscriptionFirstStatus>;
  id: Scalars['Int']['output'];
  invoiceStatus: GqlInvoiceStatus;
  isMonthly: Scalars['Boolean']['output'];
  isSchedulingToCancellation: Scalars['Boolean']['output'];
  isYearly: Scalars['Boolean']['output'];
  orderKey: GqlOrderKey;
  orderName: Scalars['String']['output'];
  pdfInvoiceUrl?: Maybe<Scalars['String']['output']>;
  planId?: Maybe<GqlSubscriptionPlan>;
  prentOrderId?: Maybe<Scalars['Int']['output']>;
  promocode?: Maybe<PromocodeType>;
  promocodeDiscount?: Maybe<Scalars['Float']['output']>;
  provider: GqlSubscriptionProvider;
  serviceName: GqlPaymentServiceName;
  status: GqlSubscriptionStatus;
  stripeInvoiceUrl?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
};


export type PaymentOrderTypeFinalAmountArgs = {
  calcQuantityOrder?: InputMaybe<Scalars['Boolean']['input']>;
  returnInDollars?: InputMaybe<Scalars['Boolean']['input']>;
  subtractDiscounts?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PaymentOrderTypeFinalAmountInCentArgs = {
  calcQuantityOrder?: InputMaybe<Scalars['Boolean']['input']>;
  returnInDollars?: InputMaybe<Scalars['Boolean']['input']>;
  subtractDiscounts?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentType = {
  __typename?: 'PaymentType';
  /** Returns an active ad or event promo code */
  activePromocode?: Maybe<PromocodeType>;
  countryPrices: CountryPricesType;
  currencies: Array<PaymentCurrencyType>;
  currencyPriceByPlanId: CurrencyPricesType;
  /** Returns and validates a promo code by its code (by coupon) */
  findAndValidPromocode?: Maybe<PromocodeType>;
  isAllowBuyMultiSubscription: Scalars['Boolean']['output'];
  /** Checking for at least one lite status for a user */
  isUserHasLite: Scalars['Boolean']['output'];
  /** Checking for premium status by user. */
  isUserHasPremium: Scalars['Boolean']['output'];
  /** Checking for storage premium status by user */
  isUserHasStorage: Scalars['Boolean']['output'];
  isValidCouponByCurrentUser: Scalars['Boolean']['output'];
  lastUserLiteIdWithoutQr?: Maybe<Scalars['Int']['output']>;
  /** Returns an active ad or event promo code */
  promocodeAfterGettingTrial?: Maybe<PromocodeType>;
};


export type PaymentTypeActivePromocodeArgs = {
  returnAdPromocode?: InputMaybe<Scalars['Boolean']['input']>;
  returnEventPromocode?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PaymentTypeCountryPricesArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  coupon?: InputMaybe<Scalars['String']['input']>;
  quantityOrder?: InputMaybe<Scalars['Int']['input']>;
  returnStoragePlans?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PaymentTypeCurrenciesArgs = {
  pageFilter?: InputMaybe<GqlFrontCurrencyPage>;
};


export type PaymentTypeCurrencyPriceByPlanIdArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  coupon?: InputMaybe<Scalars['String']['input']>;
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  planId: GqlSubscriptionPlan;
  quantityOrder?: InputMaybe<Scalars['Int']['input']>;
  quantityUnits?: InputMaybe<Scalars['Int']['input']>;
};


export type PaymentTypeFindAndValidPromocodeArgs = {
  coupon: Scalars['String']['input'];
  planId?: InputMaybe<GqlSubscriptionPlan>;
};


export type PaymentTypeIsValidCouponByCurrentUserArgs = {
  coupon: Scalars['String']['input'];
  planId?: InputMaybe<GqlSubscriptionPlan>;
};


export type PaymentTypePromocodeAfterGettingTrialArgs = {
  planId?: InputMaybe<GqlSubscriptionPlan>;
};

export type PlanPricesType = {
  __typename?: 'PlanPricesType';
  currenciesPrices: Array<CurrencyPricesType>;
  orderTypeKey: Scalars['String']['output'];
  planId: GqlSubscriptionPlan;
  quantityUnits?: Maybe<Scalars['Int']['output']>;
};

export type PremiumMiddlewareInput = {
  coupon?: InputMaybe<Scalars['String']['input']>;
  currencyCode?: Scalars['String']['input'];
  planId: Scalars['Int']['input'];
  quantityOrder?: InputMaybe<Scalars['Int']['input']>;
  serviceName: GqlPaymentServiceName;
  targetCancelLink?: InputMaybe<Scalars['String']['input']>;
  targetSuccessLink?: InputMaybe<Scalars['String']['input']>;
};

export type PremiumSubscriptionType = {
  __typename?: 'PremiumSubscriptionType';
  activeOrder?: Maybe<PaymentOrderType>;
  customerPortalUrl?: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isActual: Scalars['Boolean']['output'];
  isActualTrial: Scalars['Boolean']['output'];
  isCancellationPeriod: Scalars['Boolean']['output'];
  isExistSubscription: Scalars['Boolean']['output'];
  isMultipleOrder: Scalars['Boolean']['output'];
  subscriptionDueDate?: Maybe<Scalars['String']['output']>;
  trialDueDate?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};


export type PremiumSubscriptionTypeCustomerPortalUrlArgs = {
  backUrl?: InputMaybe<Scalars['String']['input']>;
};


export type PremiumSubscriptionTypeDueDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type PremiumSubscriptionTypeSubscriptionDueDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type PremiumSubscriptionTypeTrialDueDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileAdditionalInvoiceEmailInput = {
  email?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileAlternativeEmailInput = {
  email: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileGeneralInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  companyCategoryId?: InputMaybe<Scalars['String']['input']>;
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phones?: Array<UserPhoneInput>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileNotificationsInput = {
  entryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  isEmailType?: Scalars['Boolean']['input'];
  isMobileType?: Scalars['Boolean']['input'];
  qrCodesSelection?: InputMaybe<GqlQrCodesSelection>;
  types?: Array<GqlUserEmailNotification>;
};

export type ProfilePasswordInput = {
  password?: InputMaybe<Scalars['String']['input']>;
  plainPassword?: InputMaybe<Scalars['String']['input']>;
};

export type PromocodeType = {
  __typename?: 'PromocodeType';
  code: Scalars['String']['output'];
  discount: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  isTest: Scalars['Boolean']['output'];
};

export type QrDescriptionUnion = ArtQrDescriptionType | BaseQrDescriptionType;

export type QrDomainOptionType = {
  __typename?: 'QrDomainOptionType';
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type QrDownloadType = {
  __typename?: 'QrDownloadType';
  contentType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  app: AppType;
  checks: AppChecksType;
  entity: EntityType;
  entryData: EntryDataType;
  folderQrZipStatus: FolderZipOutput;
  folderZipReport?: Maybe<FolderZipOutput>;
  geo: GeoDataType;
  marketing: MarketingType;
  notifications: NotificationsType;
  payment: PaymentType;
  qrDomainOptions: Array<QrDomainOptionType>;
  user: UserType;
};


export type QueryFolderQrZipStatusArgs = {
  extension?: InputMaybe<Scalars['String']['input']>;
  folderId: Scalars['Int']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFolderZipReportArgs = {
  folderId: Scalars['Int']['input'];
};

export type ReferralType = {
  __typename?: 'ReferralType';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['String']['output'];
  refill: Scalars['Float']['output'];
  status: Scalars['Boolean']['output'];
  subscriptionPlanId?: Maybe<GqlSubscriptionPlan>;
  totalScans: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
  username: Scalars['String']['output'];
};


export type ReferralTypeCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type ReferrerType = {
  __typename?: 'ReferrerType';
  actualBalance: Scalars['Float']['output'];
  code: Scalars['String']['output'];
  minWithdrawalAmount: Scalars['Float']['output'];
  referrals: Array<ReferralType>;
  totalBalance: Scalars['Float']['output'];
  withdrawals: Array<ReferrerWithdrawalType>;
};


export type ReferrerTypeReferralsArgs = {
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReferrerWithdrawalDataType = {
  __typename?: 'ReferrerWithdrawalDataType';
  bankAddress?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<CityType>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isSaved: Scalars['Boolean']['output'];
  payoneerRecipientAccount?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  recipientAddress?: Maybe<Scalars['String']['output']>;
  recipientAddressIndex?: Maybe<Scalars['String']['output']>;
  recipientEmail?: Maybe<Scalars['String']['output']>;
  recipientName?: Maybe<Scalars['String']['output']>;
  recipientType?: Maybe<GqlRecipientType>;
  swiftBicCode?: Maybe<Scalars['String']['output']>;
};

export type ReferrerWithdrawalType = {
  __typename?: 'ReferrerWithdrawalType';
  amount: Scalars['Float']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  methodName: Scalars['String']['output'];
  status: GqlReferrerWithdrawalStatus;
  type: GqlReferrerWithdrawalType;
  withdrawalData?: Maybe<ReferrerWithdrawalDataType>;
};


export type ReferrerWithdrawalTypeCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type SetNoFolderInput = {
  ids: Array<Scalars['Int']['input']>;
};

export type ShareEmailInput = {
  change?: Scalars['Int']['input'];
  role: GqlSharedUserRole;
  username: Scalars['String']['input'];
};

export type ShareFolderInput = {
  folderId: Scalars['Int']['input'];
  usernames: Array<ShareEmailInput>;
};

export type ShortLinkCsvImportResultOutput = {
  __typename?: 'ShortLinkCsvImportResultOutput';
  createdCount: Scalars['Int']['output'];
  errorCount: Scalars['Int']['output'];
  errors: Array<ShortLinkCsvRowErrorOutput>;
  reportDownloadUrl: Scalars['String']['output'];
  reportId: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
  totalRows: Scalars['Int']['output'];
};

export type ShortLinkCsvRowErrorOutput = {
  __typename?: 'ShortLinkCsvRowErrorOutput';
  link: Scalars['String']['output'];
  message: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
};

export type StorageInfoType = {
  __typename?: 'StorageInfoType';
  additionalSizeInB?: Maybe<Scalars['Int']['output']>;
  additionalSizeInGb?: Maybe<Scalars['Float']['output']>;
  additionalSizeInMb?: Maybe<Scalars['Float']['output']>;
  allowedSizeInB?: Maybe<Scalars['Int']['output']>;
  allowedSizeInGb?: Maybe<Scalars['Float']['output']>;
  allowedSizeInMb?: Maybe<Scalars['Float']['output']>;
  filledSizeByConstructorInB: Scalars['Int']['output'];
  filledSizeByConstructorInGb: Scalars['Float']['output'];
  filledSizeByConstructorInMb: Scalars['Float']['output'];
  filledSizeInB: Scalars['Int']['output'];
  filledSizeInGb: Scalars['Float']['output'];
  filledSizeInMb: Scalars['Float']['output'];
  freePremiumSizeInB?: Maybe<Scalars['Int']['output']>;
  freePremiumSizeInGb?: Maybe<Scalars['Float']['output']>;
  freePremiumSizeInMb?: Maybe<Scalars['Float']['output']>;
  freeSizeInB: Scalars['Int']['output'];
  freeSizeInGb: Scalars['Float']['output'];
  freeSizeInMb: Scalars['Float']['output'];
  percentageOfOccupancy: Scalars['Int']['output'];
  totalAllowedFileSizeInB: Scalars['Int']['output'];
  totalAllowedFileSizeInGb: Scalars['Float']['output'];
  totalAllowedFileSizeInMb: Scalars['Float']['output'];
};


export type StorageInfoTypeFilledSizeInBArgs = {
  subtractFreeSize?: InputMaybe<Scalars['Boolean']['input']>;
};


export type StorageInfoTypeFilledSizeInGbArgs = {
  subtractFreeSize?: InputMaybe<Scalars['Boolean']['input']>;
};


export type StorageInfoTypeFilledSizeInMbArgs = {
  subtractFreeSize?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StorageMiddlewareInput = {
  coupon?: InputMaybe<Scalars['String']['input']>;
  currencyCode?: Scalars['String']['input'];
  planId: Scalars['Int']['input'];
  quantityOrder?: InputMaybe<Scalars['Int']['input']>;
  quantityUnits?: InputMaybe<Scalars['Int']['input']>;
  serviceName: GqlPaymentServiceName;
  targetCancelLink?: InputMaybe<Scalars['String']['input']>;
  targetSuccessLink?: InputMaybe<Scalars['String']['input']>;
};

export type StorageSubscriptionType = {
  __typename?: 'StorageSubscriptionType';
  activeOrder?: Maybe<PaymentOrderType>;
  cleaningDate: Scalars['String']['output'];
  customerPortalUrl?: Maybe<Scalars['String']['output']>;
  dueDate: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isCancellationPeriod: Scalars['Boolean']['output'];
  isExistSubscription: Scalars['Boolean']['output'];
  isMultipleOrder: Scalars['Boolean']['output'];
  subscriptionDueDate?: Maybe<Scalars['String']['output']>;
};


export type StorageSubscriptionTypeCleaningDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type StorageSubscriptionTypeCustomerPortalUrlArgs = {
  backUrl?: InputMaybe<Scalars['String']['input']>;
};


export type StorageSubscriptionTypeDueDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type StorageSubscriptionTypeSubscriptionDueDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type SupportMessageInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  emailRepeat?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  messageText: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type TimezonePaginatedType = {
  __typename?: 'TimezonePaginatedType';
  count: Scalars['Int']['output'];
  items: Array<TimezoneType>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type TimezoneType = {
  __typename?: 'TimezoneType';
  GMT: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  timeOffset: Scalars['Int']['output'];
  timeOffsetDst: Scalars['Int']['output'];
};

export type UserAlternativeNotifyEmailType = {
  __typename?: 'UserAlternativeNotifyEmailType';
  code?: Maybe<Scalars['String']['output']>;
  confirmed: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  expiredAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};


export type UserAlternativeNotifyEmailTypeExpiredAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};

export type UserCompanyInformationType = {
  __typename?: 'UserCompanyInformationType';
  address?: Maybe<Scalars['String']['output']>;
  companyCategory?: Maybe<CompanyParentCategory>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  taxNumber?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type UserEmailNotificationType = {
  __typename?: 'UserEmailNotificationType';
  id: Scalars['Int']['output'];
  typeEnum?: Maybe<GqlUserEmailNotification>;
};

export type UserEntryNotificationType = {
  __typename?: 'UserEntryNotificationType';
  entryId: Scalars['Int']['output'];
  entryTitle: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type UserPhoneInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
};

export type UserPhoneType = {
  __typename?: 'UserPhoneType';
  id: Scalars['Int']['output'];
  number: Scalars['String']['output'];
};

export type UserPushNotificationOnOffType = {
  __typename?: 'UserPushNotificationOnOffType';
  entriesSelectionType: GqlQrCodesSelection;
  id: Scalars['Int']['output'];
  isEmailType: Scalars['Boolean']['output'];
  isMobileType: Scalars['Boolean']['output'];
};

export type UserSegmentType = {
  __typename?: 'UserSegmentType';
  id: Scalars['Int']['output'];
  slug: GqlUserSegment;
  title: Scalars['String']['output'];
};

export type UserTabLogInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  path: Scalars['String']['input'];
};

export type UserTwoFactorStatusType = {
  __typename?: 'UserTwoFactorStatusType';
  isEnabled: Scalars['Boolean']['output'];
  isPendingConfirmation: Scalars['Boolean']['output'];
  qrCodeUri?: Maybe<Scalars['String']['output']>;
  secretCode?: Maybe<Scalars['String']['output']>;
};

export type UserType = {
  __typename?: 'UserType';
  additionalInvoiceEmail?: Maybe<Scalars['String']['output']>;
  alternativeNotifyEmail: Array<UserAlternativeNotifyEmailType>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  companyInformation?: Maybe<UserCompanyInformationType>;
  country?: Maybe<CountryType>;
  createdAt?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<DomainType>;
  emailNotificationTypes: Array<UserEmailNotificationType>;
  entriesNotification: Array<UserEntryNotificationType>;
  firstName?: Maybe<Scalars['String']['output']>;
  folders: Array<FolderType>;
  fullName?: Maybe<Scalars['String']['output']>;
  hasNonShortLinkEntry: Scalars['Boolean']['output'];
  hasShortLinkEntry: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  integrationInfo?: Maybe<IntegrationInfoType>;
  isAccountBlockedByPremium: Scalars['Boolean']['output'];
  isAdmin: Scalars['Boolean']['output'];
  isMailingSubscribe: Scalars['Boolean']['output'];
  isShowSegmentModal: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  language?: Maybe<LanguageType>;
  lastName?: Maybe<Scalars['String']['output']>;
  liteSubscriptions: Array<LiteSubscriptionType>;
  paymentHistory: Array<PaymentOrderType>;
  phones: Array<UserPhoneType>;
  premiumSubscription?: Maybe<PremiumSubscriptionType>;
  pushNotificationOnOffType?: Maybe<UserPushNotificationOnOffType>;
  referrer?: Maybe<ReferrerType>;
  roles: Array<GqlUserRole>;
  segments: Array<UserSegmentType>;
  storageInfo?: Maybe<StorageInfoType>;
  storageSubscription?: Maybe<StorageSubscriptionType>;
  templates: Array<EntryTemplateType>;
  timezone?: Maybe<TimezoneType>;
  twoFactorStatus?: Maybe<UserTwoFactorStatusType>;
  undownloadedFolderReports: Array<FolderUndownloadedReportOutput>;
  userIdHash: Scalars['String']['output'];
  username: Scalars['String']['output'];
};


export type UserTypeCreatedAtArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type UserTypeDateOfBirthArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


export type UserTypeLiteSubscriptionsArgs = {
  addOutdatedFails?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserTypePremiumSubscriptionArgs = {
  addOutdatedFails?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserTypeStorageSubscriptionArgs = {
  addOutdatedFails?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VerifyDomainInput = {
  domainName: Scalars['String']['input'];
};
